import statisticsLight from '@ihs-widget/assets/svg/statsConsoleAndOverview/statistics_fill.svg';
import statisticsDark from '@ihs-widget/assets/svg/statsConsoleAndOverview/statistics_fill_dark.svg';
import { useTheme } from '../../../../../stores/useTheme';
import Spinner from '@ihs-widget/components/common/Spinner';
import SmallSpinner from '@ihs-widget/components/common/SmallSpinner';
import { truncateString } from '@ihs-widget/utils/functions';
import { T, Version } from "@ihs-widget/utils/enums";
import { useLanguage } from "@ihs-widget/utils/hooks/useLanguage";
import { useTranslations } from "../../../../../translation/TranslationContext";
import { version } from 'react-dom';
import { useColorContext } from '@ihs-widget/stores/ColorContext';
import { useVersion } from '@ihs-widget/utils/hooks/useVersion';

interface IStandardStatsConsoleProps {
    title: string;
    homeScore: number;
    awayScore: number;
    goalsLineWidthHome: number;
    goalsLineWidthAway: number;
    onClickExpand?: () => void;
}

const StandardStatsConsole = ({
    title,
    homeScore,
    awayScore,
    goalsLineWidthHome,
    goalsLineWidthAway,
    onClickExpand = () => {}
}: IStandardStatsConsoleProps) => {
    const { theme } = useTheme();
    const language = useLanguage();
    const translations = useTranslations(language);
    const { colors } = useColorContext();
    const { isV1 } = useVersion();

    const LeftLine = () => {
        return (
            <div className='flex flex-col bg-base080 rounded-[8px] m-[8px] dark:bg-base120'>
                <div className='h-[10px] w-[2px] bg-base090 rounded-[8px] dark:bg-base'></div>
            </div>
        )
    }

    const StatsIcon = ({ theme }: { theme: string }) => {
        return (
            <div
                className='h-full flex flex-col justify-center ml-[8px] pr-[8px]'>
                <img
                    src={theme === T.DARK ? statisticsDark : statisticsLight}
                    className={`
                        w-[20px] h-[20px] min-w-[20px] min-h-[20px]`}
                    alt="extend"
                />
            </div>
        )
    }

    const ResultsLines = () => {
        return (
            <div className="w-full flex items-center gap-[2px]">
                <div className={`h-[4px] w-full rounded-[8px] ${goalsLineWidthHome === 0 ? 'hidden' : ''}`}
                    style={{ width: `${goalsLineWidthHome}%`, backgroundColor: colors?.homeColor, border: `0.6px solid ${colors?.borderColor}` }}
                />
                <div
                    className={`h-[4px] w-full rounded-[8px] ${goalsLineWidthAway === 0 ? 'hidden' : ''}`}
                    style={{ width: `${goalsLineWidthAway}%`, backgroundColor: colors?.awayColor, border: `0.6px solid ${colors?.borderColor}` }}
                />
            </div>
        )
    }

    const Titles = () => {
        return (
            <div className='h-[16px] w-full flex justify-between items-center text-[12px] font-medium '>
                {title !== null && homeScore !== null ? <div data-testid="stats-console-standard-header-home-score" style={{ color: theme === T.LIGHT ? '#111111' : '#FFFFFF' }}>{truncateString(homeScore, 3)}</div> : <SmallSpinner />}
                {title !== null ? <div data-testid="stats-console-standard-header-title" style={{ color: theme === T.LIGHT ? colors?.textColor : '#FFFFFF' }}>{truncateString(translations[`${title}` as keyof typeof translations] || '', 34)}</div> : <SmallSpinner />}
                {title !== null && awayScore !== null ? <div data-testid="stats-console-standard-header-away-score" style={{ color: theme === T.LIGHT ? '#111111' : '#FFFFFF' }}>{truncateString(awayScore, 3)}</div> : <SmallSpinner />}
            </div>
        )
    }


    return (
        <div data-testid="stats-console-standard-view" className='w-full flex cursor-pointer' onClick={onClickExpand}>
            <LeftLine />
            <div className={`flex flex-col justify-start h-full w-full rounded-[4px] text-[14px]  gap-[6px] pb-[8.5px] pt-[6.5px]
                ${isV1 ? 'bg-monoY dark:bg-base110' : 'dark:bg-[#222222] bg-monoY'}`}>
                <Titles />
                <ResultsLines />
            </div>
            <StatsIcon theme={theme} />
        </div>
    )
}

export default StandardStatsConsole;